import { render, staticRenderFns } from "./personalInforSecond.vue?vue&type=template&id=09962854&scoped=true&"
import script from "./personalInforSecond.vue?vue&type=script&lang=js&"
export * from "./personalInforSecond.vue?vue&type=script&lang=js&"
import style0 from "./personalInforSecond.vue?vue&type=style&index=0&id=09962854&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09962854",
  null
  
)

export default component.exports